import React, { useRef, useState } from 'react';
import { TIMES } from "./times";
import { timeToSeconds } from "~/utils/utils";
import "./style.less";

const DEF_TIME = "";

export default function DancePage() {
	const inputEl = useRef(null);
	const videoEl = useRef(null);
	const [showTimes, setShowTimes] = useState(false);
	const [selectedItem, setSelectedItem] = useState(null);
	const [selectedNextItem, setNextSelectedItem] = useState(null);
	const [stopTime, setStopTime] = useState(DEF_TIME);

	function setTime(value) {
		// [s]
		videoEl.current.pause();
		videoEl.current.currentTime = timeToSeconds(value);
		//videoEl.current.play();
	}

	function getItemIndex(time) {
		for (let ind = 0; ind < TIMES.length; ind++) {
			if (TIMES[ind].time === time) {
				return ind;
			}
		}

		return -1;
	}

	function onClick() {
		const value = inputEl.current.value.trim();

		setTime(value);
	}

	function linkSetTime(item) {
		const ind = getItemIndex(item.time);

		setStopTime(ind > -1 && TIMES[ind + 1] ? TIMES[ind + 1].time : DEF_TIME);
		setShowTimes(false);
		setTime(item.time);
		setSelectedItem(item);
		setNextSelectedItem(TIMES[ind + 1] || null);
	}

	function clearTimeClick() {
		setSelectedItem(null);
		setNextSelectedItem(null);
		setStopTime(DEF_TIME);
	}

	function onTimeUpdate() {
		const time = stopTime ? timeToSeconds(stopTime) : 0;
		const curTime = videoEl.current.currentTime;

		if (time && curTime > time) {
			videoEl.current.pause();
			setStopTime(DEF_TIME);
		}
	}

	/* eslint-disable react/no-array-index-key */
	return <div className="dancePage">
		<h2 className="dancePage__title">Tanec</h2>
		<div>
			<video src="/videos/svatebni-video.mp4" className="dancePage__videoElem" controls={true} ref={videoEl} onTimeUpdate={onTimeUpdate} />
		</div>
		<div>
			<input type="text" className="dancePage__inputText" defaultValue="0:00" ref={inputEl} />
			<button type="button" onClick={onClick} className="dancePage__btn">Nastavit čas</button>
			<button type="button" onClick={() => setShowTimes(!showTimes)} className="dancePage__btn">Seznam časů</button>
		</div>
		{ showTimes
			? <div className="dancePage__timesPopup">
				<ul>
					{TIMES.map((partItem, partInd) => <li key={`partInd${partInd}`} className="dancePage__item">
						<a href="#" onClick={() => linkSetTime(partItem)}>
							<span className="dancePage__itemTime">[{partItem.time}]</span>
							<span className="dancePage__itemText">{partItem.text}</span></a>
					</li>)}
				</ul>
			</div>
			: <>
			</>
		}
		<div className="dancePage__selectedTime" style={{ display: selectedItem ? "block" : "none" }}>
			<div>
				Vybraný čas: {selectedItem ? <a href="#" onClick={() => linkSetTime(selectedItem)}>[{selectedItem.time}]{stopTime ? ` - [${stopTime}] ` : ` `}{selectedItem.text}</a> : null}
			</div>
			{selectedNextItem
				? <div>
					<span>Následující krok: </span>
					<a href="#" onClick={() => linkSetTime(selectedNextItem)}>[{selectedNextItem.time}] {selectedNextItem.text}</a>
				</div>
				: null
			}
			<div>
				<button type="button" onClick={clearTimeClick} className="dancePage__btn clear">Smazat</button>
			</div>
		</div>
	</div>;
}
